import React, {useState} from 'react';
import {Box, Button} from '@mui/material';
import {BuilderFeesBreakdown} from './BuilderFeesBreakdown';
import {SummarySection} from '../../../pages/HandoverSummaryPage/SummarySection';
import {FeesBreakdownSection} from '../../../pages/HandoverSummaryPage/FeesBreakdownSection';
import ErrorBoundary from '../../../components/ErrorBoundary/ErrorBoundary';

/**
 * Dentist-only fee calculator section for the handover summary. Renders the
 * builder-specific fees breakdown and offers a toggle to additionally show the
 * BAU Fees Breakdown for comparison. Visibility is gated by the caller
 * (HandoverFeesSummary) via `can_access_dentist_recommendation_builder`.
 */
export const BuilderFeeCalculator: React.FC = () => {
  const [showBauFees, setShowBauFees] = useState(false);

  return (
    <>
      <SummarySection
        editable={false} // this is handled by the BE for this component
        step="tasks" // same as above
        title="Fees Calculator"
        test="builder-fees"
      >
        <ErrorBoundary inline>
          <BuilderFeesBreakdown />
        </ErrorBoundary>
      </SummarySection>
      <Box display="flex" justifyContent="flex-end" my={1}>
        <Button
          variant="outlined"
          color="primary"
          data-test="toggle-bau-fees"
          onClick={() => setShowBauFees((prev) => !prev)}
        >
          {showBauFees ? 'Hide BAU fees breakdown' : 'Show BAU fees breakdown'}
        </Button>
      </Box>
      {showBauFees && <FeesBreakdownSection />}
    </>
  );
};
